import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosAdapter } from "../../../auth/axiosAdapter";
import { zumosApiConstants } from "../../../constants/ZumosConstants";

export const patchOrderItem = createAsyncThunk('order/patchOrderItem', (data) => {
  const orderId = data.orderId;
  const orderItemId = data.orderItemId;
  delete data.orderId;
  delete data.orderItemId;
  console.log("orderSlice::patchOrderItem:: " + JSON.stringify(data))
  return axiosAdapter().patch(`${zumosApiConstants.ORDER_RESOURCE}/${orderId}/item/${orderItemId}`, data)
    .then((response) => response.data)
})


export const patchOrderItemFullfilled = (state, action) => {
  state.orders = state.orders.map((order) => {
    if (order._id === action.payload._id) {
      return action.payload;
    }
    return order;
  });
  state.loading = false;
  state.error = ''
};
export const patchOrderItemPending = (state) => {
  state.loading = true;
};
export const patchOrderItemRejected = (state, action) => {
  state.loading = false;
  state.error = action.error.message
}